/** How long to keep data cached while on the site */
export const CACHE_DURATION = 1000 * 60 * 60 /** 1 hour in milliseconds */

/** Margin configuration for the SVG container */
export const MARGIN = { top: 50, right: 600, bottom: 50, left: 10 }

/** Default width of the visualization container in pixels */
export const DEFAULT_WIDTH = 1200

/** Minimum height of the visualization */
export const MIN_HEIGHT = 600

/** Maximum height of the visualization to prevent excessive scaling */
export const MAX_HEIGHT = 2000

/** Minimum vertical space between nodes */
export const HEIGHT_PER_NODE = 30

/** Width of metadata visualization bars in pixels */
export const BAR_WIDTH = 100

/** Height of metadata visualization bars in pixels */
export const BAR_HEIGHT = 12

/** Vertical spacing between bars in pixels */
export const BAR_SPACING = 2

/** Horizontal offset for text labels from nodes in pixels */
export const LABEL_OFFSET = 10

/** Radius of tree nodes in pixels */
export const NODE_RADIUS = 3

/** Minimum zoom constraint*/
export const MIN_ZOOM = 0.5

/** Maximum zoom constraint*/
export const MAX_ZOOM = 3
